import { render, staticRenderFns } from "./BreakTheWallLeftBar.vue?vue&type=template&id=f5de150a&scoped=true"
import script from "./BreakTheWallLeftBar.vue?vue&type=script&lang=js"
export * from "./BreakTheWallLeftBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5de150a",
  null
  
)

export default component.exports